"use client";

import { Breadcrumb, Button, HStack, VStack } from "@chakra-ui/react";
import WithBreadcrumb from "@/shared/ui/navigation/WithBreadcrumb";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import WithLongPress from "@/shared/ui/gestures/WithLongPress";
import { iconSizePresets } from "@/shared/config/iconSizePresets";
import type { PagePathType } from "@/shared/config/app";

interface SearchDialogHeaderProps {
  breadcrumbs: {
    page: PagePathType;
    perspective?: string;
  };
  showPerspectiveBreadcrumb: boolean;
  hasActiveQuery: boolean;
  hasNonDefaultSearchAdjustments: boolean;
  onResetCriteria: () => void;
  onClose: () => void;
  onLongPressReset: () => void;
}

export default function SearchDialogHeader({
  breadcrumbs,
  showPerspectiveBreadcrumb,
  hasActiveQuery,
  hasNonDefaultSearchAdjustments,
  onResetCriteria,
  onClose,
  onLongPressReset,
}: SearchDialogHeaderProps) {
  return (
    <VStack align="stretch">
      <HStack justify="space-between">
        <WithBreadcrumb>
          {breadcrumbs.page && (
            <Breadcrumb.Item>{breadcrumbs.page}</Breadcrumb.Item>
          )}
          {showPerspectiveBreadcrumb && breadcrumbs.perspective && (
            <>
              <Breadcrumb.Separator />
              <Breadcrumb.Item>{breadcrumbs.perspective}</Breadcrumb.Item>
            </>
          )}
        </WithBreadcrumb>
        <WithLongPress
          onLongPress={onLongPressReset}
          enabled={hasNonDefaultSearchAdjustments}
          longPressHint={
            hasNonDefaultSearchAdjustments
              ? "Press long to reset filters"
              : undefined
          }
        >
          <Button variant="ghost" onClick={onClose}>
            <GenericIcon
              icon="close"
              size={iconSizePresets.actionButton}
              humanReadable="Close search dialog"
            />
          </Button>
        </WithLongPress>
      </HStack>

      <HStack>
        <Button
          variant="ghost"
          hidden={!hasActiveQuery}
          onClick={onResetCriteria}
        >
          <GenericIcon
            icon="reset"
            size={iconSizePresets.actionButton}
            humanReadable="Reset search query"
          />
        </Button>
      </HStack>
    </VStack>
  );
}
